import { ICurrency } from "../../models/ICurrency";
import { CURRENCY_GET_CURRENCY } from "./currency-types";

export const getCurrency = (currency: ICurrency[]) => (dispatch: any) =>
  dispatch({ type: CURRENCY_GET_CURRENCY, payload: currency });
